import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import StartAConversation from "./sections/StartAConversation";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <StartAConversation />
      <Footer />
    </div>;
}